import React from 'react'

import styles from './BannerMobilab.scss'
import ResponsiveImg from '../../common/ResponsiveImg'
import LocaleText from '../../common/LocaleText'
import { useLocale } from '../../hocs/hooks'

const BannerMobilab = ({url, srcSet, isTop, title, description}:
  {url: string, srcSet?: string, isTop?: boolean, title?: string, description?: string}) => {
  const locale = useLocale()

  return (
    <div className={[styles.mb64, styles.banner].join(' ')}>
      <a href={`/${locale}/mobilab`}>
        <ResponsiveImg
          url={url}
          caption=""
          srcSet={srcSet}
        />
      </a>
      <a href={`/${locale}/mobilab`} className={styles.box}>
        <div className={styles.center}>
          <div className={styles.text}>
            {isTop && <LocaleText ja='はじめての方へ' en={'For beginners'}/>}
            {!isTop && !!title ? title : ''}
          </div>
          <div style={{whiteSpace: 'pre-wrap'}} className={[styles.text, styles.text24].join(' ')}>
            {isTop && <LocaleText ja={'キャンピングカーを\n試乗&体験しよう！'} en={'The camper\nTake a test drive & experience!'}/>}
            {!isTop && !!description ? description : ''}
          </div>
          <div className={[styles.btn, styles.textBtn].join(' ')}>
            <LocaleText ja={'詳細はこちら'} en={'Click for details'}/>
          </div>
        </div>
      </a>
    </div>
  )
}
BannerMobilab.displayName = 'BasicSearch'
export default BannerMobilab
